
import GitHubProfile from "./GitHubProfile";


const MyGitHub = () => {
  return (
    <>
      <div name="my-github">{<GitHubProfile /> }</div>
    </>
  );
};

export default MyGitHub;
